import { useQuery } from "@tanstack/react-query";
import { getAtreemoResources } from "../../api/bAtreemoApi";

export const useGetAtreemoResources = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["atreemo-resources", organisationId],
    queryFn: () => getAtreemoResources(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
